import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _fe3ad852 = () => interopDefault(import('../pages/actions/index.vue' /* webpackChunkName: "pages/actions/index" */))
const _3f068608 = () => interopDefault(import('../pages/brands/index.vue' /* webpackChunkName: "pages/brands/index" */))
const _59afd69c = () => interopDefault(import('../pages/cart/index.vue' /* webpackChunkName: "pages/cart/index" */))
const _dcd7101a = () => interopDefault(import('../pages/catalog/index.vue' /* webpackChunkName: "pages/catalog/index" */))
const _257d7aef = () => interopDefault(import('../pages/collections/index.vue' /* webpackChunkName: "pages/collections/index" */))
const _4161b152 = () => interopDefault(import('../pages/company/index.vue' /* webpackChunkName: "pages/company/index" */))
const _5c37c5bf = () => interopDefault(import('../pages/compare/index.vue' /* webpackChunkName: "pages/compare/index" */))
const _46d34487 = () => interopDefault(import('../pages/delete-account/index.vue' /* webpackChunkName: "pages/delete-account/index" */))
const _fa2de1b4 = () => interopDefault(import('../pages/favourites/index.vue' /* webpackChunkName: "pages/favourites/index" */))
const _09579506 = () => interopDefault(import('../pages/help/index.vue' /* webpackChunkName: "pages/help/index" */))
const _7cbea6aa = () => interopDefault(import('../pages/info/index.vue' /* webpackChunkName: "pages/info/index" */))
const _22cdd1fa = () => interopDefault(import('../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _528d6046 = () => interopDefault(import('../pages/logout/index.vue' /* webpackChunkName: "pages/logout/index" */))
const _59d7228f = () => interopDefault(import('../pages/news/index.vue' /* webpackChunkName: "pages/news/index" */))
const _0b07d4a8 = () => interopDefault(import('../pages/order/index.vue' /* webpackChunkName: "pages/order/index" */))
const _1f9dfd88 = () => interopDefault(import('../pages/personal/index.vue' /* webpackChunkName: "pages/personal/index" */))
const _5f7be140 = () => interopDefault(import('../pages/products/index.vue' /* webpackChunkName: "pages/products/index" */))
const _094bdc6e = () => interopDefault(import('../pages/stores/index.vue' /* webpackChunkName: "pages/stores/index" */))
const _5ee4e4d6 = () => interopDefault(import('../pages/video/index.vue' /* webpackChunkName: "pages/video/index" */))
const _0b089d95 = () => interopDefault(import('../pages/company/about/index.vue' /* webpackChunkName: "pages/company/about/index" */))
const _0ce47161 = () => interopDefault(import('../pages/company/contacts/index.vue' /* webpackChunkName: "pages/company/contacts/index" */))
const _e71c95b0 = () => interopDefault(import('../pages/company/requisites/index.vue' /* webpackChunkName: "pages/company/requisites/index" */))
const _2aff4901 = () => interopDefault(import('../pages/order/pay/index.vue' /* webpackChunkName: "pages/order/pay/index" */))
const _5208a688 = () => interopDefault(import('../pages/order/pay-error/index.vue' /* webpackChunkName: "pages/order/pay-error/index" */))
const _220dfa04 = () => interopDefault(import('../pages/order/pay-ok/index.vue' /* webpackChunkName: "pages/order/pay-ok/index" */))
const _45ab48ba = () => interopDefault(import('../pages/personal/bonuses/index.vue' /* webpackChunkName: "pages/personal/bonuses/index" */))
const _55723ea4 = () => interopDefault(import('../pages/personal/orders/index.vue' /* webpackChunkName: "pages/personal/orders/index" */))
const _31c31e56 = () => interopDefault(import('../pages/personal/profile/index.vue' /* webpackChunkName: "pages/personal/profile/index" */))
const _795f5692 = () => interopDefault(import('../pages/personal/orders/__id/index.vue' /* webpackChunkName: "pages/personal/orders/__id/index" */))
const _dfdb95ee = () => interopDefault(import('../pages/actions/__id/index.vue' /* webpackChunkName: "pages/actions/__id/index" */))
const _7832f978 = () => interopDefault(import('../pages/brands/__id/index.vue' /* webpackChunkName: "pages/brands/__id/index" */))
const _d698eb86 = () => interopDefault(import('../pages/catalog/__slug/index.vue' /* webpackChunkName: "pages/catalog/__slug/index" */))
const _7cac73c1 = () => interopDefault(import('../pages/collections/__slug/index.vue' /* webpackChunkName: "pages/collections/__slug/index" */))
const _78d1451a = () => interopDefault(import('../pages/help/__slug/index.vue' /* webpackChunkName: "pages/help/__slug/index" */))
const _5e50afa6 = () => interopDefault(import('../pages/info/__slug/index.vue' /* webpackChunkName: "pages/info/__slug/index" */))
const _8c7bcd5e = () => interopDefault(import('../pages/news/__id/index.vue' /* webpackChunkName: "pages/news/__id/index" */))
const _5c20f1c0 = () => interopDefault(import('../pages/products/__id/index.vue' /* webpackChunkName: "pages/products/__id/index" */))
const _803c9a5c = () => interopDefault(import('../pages/stores/__id/index.vue' /* webpackChunkName: "pages/stores/__id/index" */))
const _07fb4d69 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/actions",
    component: _fe3ad852,
    name: "actions"
  }, {
    path: "/brands",
    component: _3f068608,
    name: "brands"
  }, {
    path: "/cart",
    component: _59afd69c,
    name: "cart"
  }, {
    path: "/catalog",
    component: _dcd7101a,
    name: "catalog"
  }, {
    path: "/collections",
    component: _257d7aef,
    name: "collections"
  }, {
    path: "/company",
    component: _4161b152,
    name: "company"
  }, {
    path: "/compare",
    component: _5c37c5bf,
    name: "compare"
  }, {
    path: "/delete-account",
    component: _46d34487,
    name: "delete-account"
  }, {
    path: "/favourites",
    component: _fa2de1b4,
    name: "favourites"
  }, {
    path: "/help",
    component: _09579506,
    name: "help"
  }, {
    path: "/info",
    component: _7cbea6aa,
    name: "info"
  }, {
    path: "/login",
    component: _22cdd1fa,
    name: "login"
  }, {
    path: "/logout",
    component: _528d6046,
    name: "logout"
  }, {
    path: "/news",
    component: _59d7228f,
    name: "news"
  }, {
    path: "/order",
    component: _0b07d4a8,
    name: "order"
  }, {
    path: "/personal",
    component: _1f9dfd88,
    name: "personal"
  }, {
    path: "/products",
    component: _5f7be140,
    name: "products"
  }, {
    path: "/stores",
    component: _094bdc6e,
    name: "stores"
  }, {
    path: "/video",
    component: _5ee4e4d6,
    name: "video"
  }, {
    path: "/company/about",
    component: _0b089d95,
    name: "company-about"
  }, {
    path: "/company/contacts",
    component: _0ce47161,
    name: "company-contacts"
  }, {
    path: "/company/requisites",
    component: _e71c95b0,
    name: "company-requisites"
  }, {
    path: "/order/pay",
    component: _2aff4901,
    name: "order-pay"
  }, {
    path: "/order/pay-error",
    component: _5208a688,
    name: "order-pay-error"
  }, {
    path: "/order/pay-ok",
    component: _220dfa04,
    name: "order-pay-ok"
  }, {
    path: "/personal/bonuses",
    component: _45ab48ba,
    name: "personal-bonuses"
  }, {
    path: "/personal/orders",
    component: _55723ea4,
    name: "personal-orders"
  }, {
    path: "/personal/profile",
    component: _31c31e56,
    name: "personal-profile"
  }, {
    path: "/personal/orders/:_id",
    component: _795f5692,
    name: "personal-orders-_id"
  }, {
    path: "/actions/:_id",
    component: _dfdb95ee,
    name: "actions-_id"
  }, {
    path: "/brands/:_id",
    component: _7832f978,
    name: "brands-_id"
  }, {
    path: "/catalog/:_slug",
    component: _d698eb86,
    name: "catalog-_slug"
  }, {
    path: "/collections/:_slug",
    component: _7cac73c1,
    name: "collections-_slug"
  }, {
    path: "/help/:_slug",
    component: _78d1451a,
    name: "help-_slug"
  }, {
    path: "/info/:_slug",
    component: _5e50afa6,
    name: "info-_slug"
  }, {
    path: "/news/:_id",
    component: _8c7bcd5e,
    name: "news-_id"
  }, {
    path: "/products/:_id",
    component: _5c20f1c0,
    name: "products-_id"
  }, {
    path: "/stores/:_id",
    component: _803c9a5c,
    name: "stores-_id"
  }, {
    path: "/",
    component: _07fb4d69,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
